export const ACTION_DUPLICATION = 'dupliquer';
export const ACTION_SUPPRESSION = 'supprimer';
export const ACTION_ARCHIVER = 'archiver';
export const ACTION_DESARCHIVER = 'desarchiver';
export const ACTION_CATEGORIE_OPERATION = 'categorieOperation';

export const ENCAISSEMENT = 'Encaissement';
export const FACTURATION = 'Facturation';

export const LISTE_TYPE_CALCUL_REGLE_ACHAT = [
  { key: FACTURATION, libelle: 'produitSalon.reglesAchat.typeCalculTrad.facturation' },
  { key: ENCAISSEMENT, libelle: 'produitSalon.reglesAchat.typeCalculTrad.encaissement' },
];

export const MONTANT_FIXE = 'MontantFixe';
export const POURCENTAGE_FIXE = 'PourcentageFixe';
export const TRANCHE = 'ParTranche';
export const MONTANT_PAR_PARUTION = 'MontantFixeParParution';

export const LISTE_TYPE_MONTANT_REGLE_ACHAT = [
  { key: MONTANT_FIXE, libelle: 'produitSalon.reglesAchat.typeMontantTrad.montantFixe' },
  { key: POURCENTAGE_FIXE, libelle: 'produitSalon.reglesAchat.typeMontantTrad.pourcentageFixe' },
  { key: TRANCHE, libelle: 'produitSalon.reglesAchat.typeMontantTrad.tranche' },
  { key: MONTANT_PAR_PARUTION, libelle: 'produitSalon.reglesAchat.typeMontantTrad.montantParParution' },
];

export const DATE_CREATION = 'DateCreation';
export const DATE_SIGNATURE = 'DateSignature';

export const COMMISSION_DATE_REFERENCE_TYPE = [
  { libelle: 'produitSalon.regleCommission.commissionDateReference.dateCreation', value: DATE_CREATION },
  { libelle: 'produitSalon.regleCommission.commissionDateReference.dateSignature', value: DATE_SIGNATURE },
];

export const PREMIER_PRODUIT = 'PremierProduit';
export const TOTALITE = 'Totalite';

export const COMMISSION_CALCUL_AVANCE_TYPE = [
  { libelle: 'produitSalon.regleCommission.commissionCalculAvanceType.premierProduit', value: PREMIER_PRODUIT },
  { libelle: 'produitSalon.regleCommission.commissionCalculAvanceType.totalite', value: TOTALITE },
];
